export default "__VITE_ASSET__CHg4R0ch__"